import {getUsers} from './dataGetters';

export default params => ({
  FETCH_USERS: ({dispatch}) => async () => {
    dispatch({type: 'START_LOADING'});
    try {
      const {users, totalCount} = await getUsers(params);
      dispatch({type: 'UPDATE_USERS', users, totalCount});
    } catch {
      dispatch({type: 'ERROR'});
    }
  }
});
